import { i as intelliSuggest, t as trapFocus, P as PaginationController } from "./searchspring-intelliSuggest-D_vaMJHn.js";
import { s as setAndGetSearchspringCookies } from "./manageSearchSpringCookies-BlSmBYu9.js";
import { r as renderProductCardsFromHandles } from "./render-product-cards-C86dq60y.js";
import { d as debounce } from "./_debounce-CeGyIUiF.js";
class SRP {
  //------------------------------------------------------------------------------------------------
  constructor() {
    var _a, _b;
    this.$loading = document.getElementById("loading");
    this.$hero = document.getElementById("js-hero");
    this.$noResults = document.getElementById("js-no-results");
    this.$toolbar = document.getElementById("js-toolbar");
    this.$toolbarProductsCount = document.getElementById("js-search-toolbar-product-count");
    this.$searchContainer = document.getElementById("js-search-results-container");
    this.$productsGridWrapper = document.getElementById("js-products-grid-wrapper");
    this.$productsGrid = document.getElementById("js-products-grid");
    this.$loadMoreProductsButtonWrapper = document.getElementById("js-show-more-products-trigger-wrapper");
    this.$loadMoreProductsButton = document.getElementById("js-show-more-products-trigger");
    this.$totalProductsCounts = document.querySelectorAll(".js-total-products-count");
    this.$currentProductsCount = document.getElementById("js-current-products-count");
    this.$articlesGridWrapper = document.getElementById("js-articles-grid-wrapper");
    this.$articlesGrid = document.getElementById("js-articles-grid");
    this.$loadMoreArticlesButtonWrapper = document.getElementById("js-show-more-articles-trigger-wrapper");
    this.$loadMoreArticlesButton = document.getElementById("js-show-more-articles-trigger");
    this.$totalArticlesCounts = document.querySelectorAll(".js-total-articles-count");
    this.$currentArticlesCount = document.getElementById("js-current-articles-count");
    this.$filtersDrawerWrapper = document.getElementById("js-search-filters-drawer-wrapper");
    this.$filtersBackdrop = document.getElementById("js-search-filters-backdrop");
    this.$filtersDrawer = document.getElementById("js-search-filters-drawer");
    this.$resultTypeFiltersContent = document.getElementById("js-result-type-filters-content");
    this.$productsFiltersContent = document.getElementById("js-products-filters-content");
    this.$articlesFiltersContent = document.getElementById("js-articles-filters-content");
    this.$filtersContent = document.getElementById("js-filters-content");
    this.$filtersButton = document.getElementById("js-filters-trigger");
    this.$filtersCloseButton = document.getElementById("js-close-filters-button");
    this.$filtersApplyButton = document.getElementById("js-apply-filters-button");
    this.$filtersClearButtonWrapper = document.getElementById("js-clear-filters-button-wrapper");
    this.$filtersClearButtons = document.querySelectorAll(".js-clear-filters-button");
    this.$productsFilterCountTotal = document.getElementById("js-products-filter-count-total");
    this.$articlesFilterCountTotal = document.getElementById("js-articles-filter-count-total");
    this.$productsFilterSummaryWrapper = document.getElementById("js-products-filter-summary-wrapper");
    this.$productsFilterSummary = document.getElementById("js-products-filter-summary");
    this.$articlesFilterSummaryWrapper = document.getElementById("js-articles-filter-summary-wrapper");
    this.$articlesFilterSummary = document.getElementById("js-articles-filter-summary");
    this.activeFilterGroupIndex = null;
    this.$sortModalWrapper = document.getElementById("js-search-sort-modal-wrapper");
    this.$sortModal = document.getElementById("js-search-sort-modal");
    this.$sortProductsContent = document.getElementById("js-search-sort-products-content");
    this.$sortArticlesContent = document.getElementById("js-search-sort-articles-content");
    this.$sortButton = document.getElementById("js-search-sort-trigger");
    this.$sortLabel = document.getElementById("js-search-sort-label");
    this.ssId = SDG.Data.ssId;
    this.ssBlogId = SDG.Data.ssBlogId;
    this.resultsPerPage = window.innerWidth > 768 ? _JK.collections.deskResultsPerPage : _JK.collections.mobResultsPerPage;
    this.productsPageInfo = 1;
    this.articlesPageInfo = 1;
    this.q = this.getQueryFromUrl();
    this.url = window.location.href;
    this.urlParams = new URLSearchParams(window.location.search);
    this.resultType = "products";
    this.isBestsellerScoreSortDisabled = ((_b = (_a = this.$searchContainer) == null ? void 0 : _a.dataset) == null ? void 0 : _b.isBestsellerScoreSortDisabled) === "true";
    this.productsActiveFilters = [];
    this.articlesActiveFilters = [];
    this.sort = null;
    this.sortOrder = null;
    this.ssUrlProducts = this.formatSearchSpringUrl("products");
    this.ssUrlArticles = this.formatSearchSpringUrl("articles");
  }
  /**
     * Normalizes facet data returned from Searchspring before rendering.
     *
     * - For "articles" type:
     *   • Removes any facet values whose label/value starts with "Post:"  
     *   • Strips the "Category:" prefix from the facet label, leaving only the
     *     readable category name (e.g., "Category: Style" → "Style")  
     * - For other types (e.g., "products") the facets are returned unchanged.
     *
     * The facet `value` itself is preserved for Searchspring filtering logic;
     * only the display `label` is modified. Returns a shallow clone of the
     * original data with normalized facet arrays.
     *
     * @param {Object} data - Raw Searchspring response object containing facets
     * @param {string} type - Result type ("articles" or "products")
     * @returns {Object} A copy of the response object with normalized facets
  */
  normalizeFacets(data, type) {
    if (!(data == null ? void 0 : data.facets)) return data;
    const out = { ...data, facets: data.facets.map((facet) => {
      if (facet.field !== "tags" || !Array.isArray(facet.values)) return facet;
      if (type !== "articles") return facet;
      const values = facet.values.filter((v) => !/^post:\s*/i.test(((v == null ? void 0 : v.label) ?? (v == null ? void 0 : v.value) ?? "").trim())).map((v) => ({
        ...v,
        // strip only the display label; keep v.value intact for Searchspring params
        label: ((v == null ? void 0 : v.label) ?? (v == null ? void 0 : v.value) ?? "").replace(/^category:\s*/i, "").trim()
      }));
      return { ...facet, values };
    }) };
    return out;
  }
  //------------------------------------------------------------------------------------------------
  async init() {
    const ssProductData = await this.fetchSearchSpringData("products");
    const ssArticleData = await this.fetchSearchSpringData("articles");
    this.initPage(ssProductData, ssArticleData, "replace", "both");
    if ((ssProductData == null ? void 0 : ssProductData.results.length) > 0 || (ssArticleData == null ? void 0 : ssArticleData.results.length) > 0) {
      this.initSort();
      this.addEventListeners();
    }
  }
  //------------------------------------------------------------------------------------------------
  initPage(ssProductData, ssArticleData, action = "replace", resultType = "both") {
    let displayType = resultType;
    if (ssArticleData) ssArticleData = this.normalizeFacets(ssArticleData, "articles");
    if (!ssProductData && !ssArticleData || (ssProductData == null ? void 0 : ssProductData.results.length) === 0 && (ssArticleData == null ? void 0 : ssArticleData.results.length) === 0) {
      this.displayNoResults();
      return;
    } else if ((ssProductData == null ? void 0 : ssProductData.results.length) === 0 && (ssArticleData == null ? void 0 : ssArticleData.results.length) > 0) {
      displayType = "articles";
    }
    if (action === "replace") {
      this.clearResults(resultType);
    }
    this.$loading.classList.add("hidden");
    if (resultType === "products" || resultType === "both") {
      this.productsData = ssProductData.results;
      this.productsFiltersData = ssProductData.facets || [];
      this.productsSortData = ssProductData.sorting || [];
      this.productsFilterSummaryData = ssProductData.filterSummary || {};
      this.productsPaginationData = ssProductData.pagination || {};
      this.displayProducts(action);
    }
    if (resultType === "articles" || resultType === "both") {
      this.articlesData = ssArticleData.results;
      this.articlesFiltersData = ssArticleData.facets || [];
      this.articlesSortData = ssArticleData.sorting || [];
      this.articlesFilterSummaryData = ssArticleData.filterSummary || {};
      this.articlesPaginationData = ssArticleData.pagination || {};
      this.displayArticles(action);
    }
    if (!this.filtersInitialized) {
      this.addActiveFilters();
      this.initFiltersAccordion();
      this.filtersInitialized = true;
    } else {
      this.filtersData = resultType === "articles" ? ssArticleData.facets : ssProductData.facets;
      this.updateFilterStates();
    }
    this.toggleResultType(displayType);
    this.updateCounts();
    this.$toolbar.classList.remove("hidden");
    this.$hero.classList.remove("hidden");
    this.updateSearchHistory(this.q);
  }
  updateFilterStates() {
    if (!this.filtersData || this.filtersData.length === 0) {
      console.warn("No filters to update.");
      return;
    }
    this.filtersData.forEach((filter, index) => {
      var _a;
      const filterPanel = this.$filtersContent.querySelector(`#acc-panel-${filter.field}`);
      if (!filterPanel) {
        console.warn(`No filter panel found for index ${index}`, filter);
        return;
      }
      const list = filterPanel.querySelector("ul.filter-options");
      if (!list) return;
      list.innerHTML = filter.values.map((value) => `
        <li class="filter-option redesign-body-7 py-8">
          <label class="flex items-center gap-10 cursor-pointer">
            <input 
              type="checkbox" 
              class="js-filter-option redesign-checkbox-btn" 
              data-filter="filter.${filter.field}" 
              data-value="${value.value}"
              name="${value.value}" 
              value="${value.value}" 
              ${value.active ? "checked" : ""}
              aria-checked="${value.active ? "true" : "false"}"
            >
            <span class="text-charcoal-130 flex flex-row gap-4">
              ${value.label}
              <span class="text-charcoal-80">(${value.count})</span>
            </span>
          </label>
        </li>
      `).join("");
      const filterCountEl = (_a = filterPanel.closest(".filter-item")) == null ? void 0 : _a.querySelector(`#filter_count_${filter.field}`);
      if (filterCountEl) {
        const activeCount = filter.values.filter((v) => v.active).length;
        filterCountEl.textContent = activeCount > 0 ? `(${activeCount})` : "";
      }
    });
  }
  updateFilterCount(panel, values) {
    const counterEl = panel.querySelector(".filter-count");
    if (!counterEl) return;
    const activeCount = values.filter((v) => v.active).length;
    counterEl.textContent = activeCount > 0 ? `(${activeCount})` : "";
  }
  // **************************************************************************
  // EVENTS
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  addEventListeners() {
    [
      this.$filtersButton,
      this.$filtersBackdrop,
      this.$filtersCloseButton,
      this.$filtersApplyButton
    ].forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleFiltersDrawer();
      });
    });
    this.$filtersClearButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.clearFilters();
        this.handleFilterChange("", "");
      });
    });
    this.addFilterOptionListeners();
    this.$sortButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggleSortModal();
    });
    const sortProductsOptions = this.$sortProductsContent.querySelectorAll(".js-sort-option");
    sortProductsOptions.forEach((option) => {
      option.addEventListener("change", (e) => {
        var _a, _b, _c;
        e.preventDefault();
        e.stopPropagation();
        this.sort = ((_a = e.target.dataset) == null ? void 0 : _a.sort) || null;
        this.sortLabel = ((_b = e.target.dataset) == null ? void 0 : _b.sortLabel) || null;
        this.sortOrder = ((_c = e.target.dataset) == null ? void 0 : _c.sortOrder) || null;
        this.handleSortChange("products");
      });
    });
    const sortArticlesOptions = this.$sortArticlesContent.querySelectorAll(".js-sort-option");
    sortArticlesOptions.forEach((option) => {
      option.addEventListener("change", (e) => {
        var _a, _b, _c;
        e.preventDefault();
        e.stopPropagation();
        this.sort = ((_a = e.target.dataset) == null ? void 0 : _a.sort) || null;
        this.sortLabel = ((_b = e.target.dataset) == null ? void 0 : _b.sortLabel) || null;
        this.sortOrder = ((_c = e.target.dataset) == null ? void 0 : _c.sortOrder) || null;
        this.handleSortChange("articles");
      });
    });
    this.$loadMoreProductsButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      debounce(this.showMoreProducts(), 300);
    });
    this.$loadMoreArticlesButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      debounce(this.showMoreArticles(), 300);
    });
  }
  //------------------------------------------------------------------------------------------------
  addFilterOptionListeners() {
    this.$filtersContent.addEventListener("change", (e) => {
      if (e.target.matches('.js-filter-option[type="checkbox"]') && e.target instanceof HTMLInputElement) {
        const input = e.target;
        const filterKey = input.dataset.filter;
        const filterValue = input.dataset.value;
        this.handleFilterChange(filterKey, filterValue);
      }
    });
    this.$resultTypeFiltersContent.addEventListener("change", (e) => {
      if (e.target.matches('.js-filter-option[type="radio"]') && e.target instanceof HTMLInputElement) {
        const input = e.target;
        const filterValue = input.dataset.value;
        this.toggleResultType(filterValue);
      }
    });
  }
  // **************************************************************************
  // SEARCHSPRING METHODS
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  async fetchSearchSpringData(resultType = "products") {
    const ssUrl = resultType === "products" ? this.ssUrlProducts : this.ssUrlArticles;
    try {
      const response = await fetch(ssUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching SS Data:", error);
      console.error(`  - ERR ssURL: ${ssUrl}`);
      return null;
    }
  }
  //------------------------------------------------------------------------------------------------
  formatSearchSpringUrl(resultType = "products") {
    const {
      sessionCookie,
      userId,
      pageLoadId
    } = setAndGetSearchspringCookies();
    let ssId = this.ssId;
    let pageInfo = this.productsPageInfo;
    if (resultType === "articles") {
      ssId = this.ssBlogId;
      pageInfo = this.articlesPageInfo;
    }
    const ssBaseUrl = `https://${ssId}.a.searchspring.io/api/search/search.json`;
    const baseParams = {
      resultsFormat: "native",
      siteId: ssId,
      sessionId: sessionCookie,
      userId,
      pageLoadId,
      resultsPerPage: this.resultsPerPage,
      page: pageInfo,
      q: this.q
    };
    const ssParams = new URLSearchParams(baseParams);
    if (resultType === "products" && this.productsActiveFilters) {
      this.productsActiveFilters.forEach((filter) => {
        ssParams.append(filter.key, filter.value);
      });
    }
    if (resultType === "articles" && this.articlesActiveFilters) {
      this.articlesActiveFilters.forEach((filter) => {
        ssParams.append(filter.key, filter.value);
      });
    }
    if (this.sort && this.sortOrder) {
      ssParams.append(`${this.sort}`, this.sortOrder);
    }
    const ssUrl = `${ssBaseUrl}?${ssParams.toString()}`;
    return ssUrl;
  }
  // **************************************************************************
  // DISPLAY RESULTS METHODS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  toggleResultType(resultType = "products") {
    if (resultType === "both") resultType = "products";
    this.resultType = resultType;
    this.$radioResultTypeProducts = document.getElementById("resulttype.products");
    this.$radioResultTypeArticles = document.getElementById("resulttype.articles");
    this.$productsGridWrapper.classList.add("hidden");
    this.$productsFilterCountTotal.classList.add("hidden");
    this.$productsFiltersContent.classList.add("hidden");
    this.$sortProductsContent.classList.add("hidden");
    this.$productsFilterSummaryWrapper.classList.add("hidden");
    this.$radioResultTypeProducts.checked = false;
    this.$articlesGridWrapper.classList.add("hidden");
    this.$articlesFilterCountTotal.classList.add("hidden");
    this.$articlesFiltersContent.classList.add("hidden");
    this.$sortArticlesContent.classList.add("hidden");
    this.$articlesFilterSummaryWrapper.classList.add("hidden");
    this.$radioResultTypeArticles.checked = false;
    if (resultType === "products") {
      this.$productsGridWrapper.classList.remove("hidden");
      this.$productsFilterCountTotal.classList.remove("hidden");
      this.$productsFiltersContent.classList.remove("hidden");
      this.$sortProductsContent.classList.remove("hidden");
      this.$radioResultTypeProducts.checked = true;
      if (this.$toolbarProductsCount) this.$toolbarProductsCount.classList.remove("hidden");
    } else {
      this.$articlesGridWrapper.classList.remove("hidden");
      this.$articlesFilterCountTotal.classList.remove("hidden");
      this.$articlesFiltersContent.classList.remove("hidden");
      this.$sortArticlesContent.classList.remove("hidden");
      this.$radioResultTypeArticles.checked = true;
      if (this.$toolbarProductsCount) this.$toolbarProductsCount.classList.add("hidden");
    }
    this.displayFilterSummary(resultType);
  }
  //------------------------------------------------------------------------------------------------
  displayArticles(action) {
    if (!this.articlesData || this.articlesData.length === 0) {
      this.$articlesGrid.innerHTML = '<p class="redesign-body-4 text-charcoal-100 col-span-3 text-center">No resuls with those filters.</p>';
      return;
    }
    if (action === "append") {
      this.articlesData.forEach((article) => {
        const articleCard = document.createElement("div");
        articleCard.classList.add("article-card", "basis-[calc(50%-4px)]", "lg:basis-[calc(25%_-_8px)]");
        articleCard.innerHTML = this.getArticleCardHTML(article);
        this.$articlesGrid.appendChild(articleCard);
      });
    } else {
      this.$articlesGrid.innerHTML = this.articlesData.map((article) => `
        <div class="article-card basis-[calc(50%-4px)] lg:basis-[calc(25%_-_8px)]">
          ${this.getArticleCardHTML(article)}
        </div>
      `).join("");
    }
    if (this.articlesPaginationData.currentPage < this.articlesPaginationData.totalPages) {
      this.$loadMoreArticlesButtonWrapper.classList.remove("hidden");
    } else {
      this.$loadMoreArticlesButtonWrapper.classList.add("hidden");
    }
  }
  //------------------------------------------------------------------------------------------------
  getArticleCardHTML(article) {
    return `
      <a href="${article.url}">
        <article class="text-charcoal-100">
          <div class="aspect-[1.475] bg-no-repeat bg-cover bg-top mb-16" style="background-image: url('${article.thumbnailImageUrl.replace(/(\.(jpg|jpeg|png|gif|webp))(?=\?|$)/i, "_800x$1")}');"></div>
          <h3 class="redesign-body-5 mb-12">${article.title}</h3>
          <p class="redesign-body-7">${article.content === void 0 ? article.title : article.content}</p>
        </article>
      </a>
    `;
  }
  //------------------------------------------------------------------------------------------------
  displayProducts(action) {
    var _a, _b;
    if (!this.productsData || this.productsData.length === 0) {
      this.$productsGrid.innerHTML = "<p>No products available in this collection.</p>";
      return;
    }
    intelliSuggest(this.productsData);
    const handlesToRender = this.productsData.map((product) => product.handle);
    renderProductCardsFromHandles(
      handlesToRender,
      this.$productsGrid,
      {
        view: "get-product-card",
        cardClasses: ["basis-[calc(50%-4px)]", "lg:basis-[calc(25%_-_8px)]"],
        action
      }
    );
    if (((_a = this.productsPaginationData) == null ? void 0 : _a.currentPage) < ((_b = this.productsPaginationData) == null ? void 0 : _b.totalPages)) {
      this.$loadMoreProductsButtonWrapper.classList.remove("hidden");
    } else {
      this.$loadMoreProductsButtonWrapper.classList.add("hidden");
    }
  }
  //------------------------------------------------------------------------------------------------
  showMoreProducts() {
    this.productsPageInfo += 1;
    this.ssUrlProducts = this.formatSearchSpringUrl("products");
    this.fetchSearchSpringData("products").then((ssProductData) => {
      this.initPage(ssProductData, null, "append", "products");
    }).catch((error) => {
      console.error("Error fetching more products:", error);
      this.$loadMoreButtonWrapper.classList.add("hidden");
    });
  }
  //------------------------------------------------------------------------------------------------
  showMoreArticles() {
    this.articlesPageInfo += 1;
    this.ssUrlArticles = this.formatSearchSpringUrl("articles");
    this.fetchSearchSpringData("articles").then((ssArticlesData) => {
      this.initPage(null, ssArticlesData, "append", "articles");
    }).catch((error) => {
      console.error("Error fetching more articles:", error);
      this.$loadMoreButtonWrapper.classList.add("hidden");
    });
  }
  //------------------------------------------------------------------------------------------------
  clearResults(resultType = "products") {
    if (resultType === "products") {
      this.$productsGrid.innerHTML = "";
    } else {
      this.$articlesGrid.innerHTML = "";
    }
  }
  //------------------------------------------------------------------------------------------------
  updateCounts() {
    var _a, _b;
    this.$totalProductsCounts = document.querySelectorAll(".js-total-products-count");
    this.$totalArticlesCounts = document.querySelectorAll(".js-total-articles-count");
    this.$totalProductsCounts.forEach((el) => {
      var _a2;
      el.innerHTML = ((_a2 = this.productsPaginationData) == null ? void 0 : _a2.totalResults) || 0;
    });
    this.$totalArticlesCounts.forEach((el) => {
      var _a2;
      el.innerHTML = ((_a2 = this.articlesPaginationData) == null ? void 0 : _a2.totalResults) || 0;
    });
    this.$currentProductsCount.innerHTML = ((_a = this.productsPaginationData) == null ? void 0 : _a.end) || 0;
    this.$currentArticlesCount.innerHTML = ((_b = this.articlesPaginationData) == null ? void 0 : _b.end) || 0;
    if (this.productsActiveFilters) {
      if (this.productsActiveFilters.length > 0) {
        this.$productsFilterCountTotal.innerHTML = `(${this.productsActiveFilters.length})`;
      } else {
        this.$productsFilterCountTotal.innerHTML = "";
      }
    }
    if (this.articlesActiveFilters) {
      if (this.articlesActiveFilters.length > 0) {
        this.$articlesFilterCountTotal.innerHTML = `(${this.articlesActiveFilters.length})`;
      } else {
        this.$articlesFilterCountTotal.innerHTML = "";
      }
    }
    for (var filter in this.filterCounts) {
      const count = this.filterCounts[filter] === 0 ? "" : `(${this.filterCounts[filter]})`;
      const counterID = `filter_count_${filter}`;
      const $counter = document.getElementById(counterID);
      $counter.innerHTML = count;
    }
  }
  //------------------------------------------------------------------------------------------------
  displayNoResults() {
    this.$loading.classList.add("hidden");
    this.$noResults.classList.remove("hidden");
    document.getElementById("noResultsQ").focus();
  }
  // **************************************************************************
  // SORT METHODS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  initSort() {
    this.$sortProductsContent.innerHTML = "";
    this.$sortArticlesContent.innerHTML = "";
    const productSortOptions = this.productsSortData.options.filter((sort) => {
      const isBestsellerScoreSort = sort.field === "mfield_custom_ss_bestseller_score";
      return !(isBestsellerScoreSort && this.isBestsellerScoreSortDisabled);
    });
    const hasActiveProductSort = productSortOptions.some((sort) => sort.active);
    productSortOptions.forEach((sort, index) => {
      const sortElement = document.createElement("div");
      sortElement.classList.add("redesign-body-7", "text-charcoal-100", "py-8");
      let checked = "";
      if (sort.active) {
        sortElement.classList.add("active");
        checked = "checked";
      }
      if (!hasActiveProductSort && index === 0) {
        checked = "checked";
      }
      if (checked) {
        this.$sortLabel.innerHTML = sort.label;
      }
      sortElement.innerHTML += `
          <label class="flex items-center gap-8 cursor-pointer gtm-sort" data-handle="${sort.label} : ${sort.direction}">
            <input 
              type="radio" 
              class="size-20 js-sort-option redesign-radio-btn" 
              data-sort="sort.${sort.field}"
              data-sort-order="${sort.direction}"
              data-sort-label="${sort.label}"
              name="sort"
              value="${sort.field}"
              ${checked}
            >
            ${sort.label} 
          </label>
      `;
      this.$sortProductsContent.appendChild(sortElement);
    });
    let anyActive = false;
    this.articlesSortData.options.forEach((sort, index) => {
      const sortElement = document.createElement("div");
      sortElement.classList.add("redesign-body-7", "text-charcoal-100", "py-8");
      let checked = "";
      if (sort.active) {
        sortElement.classList.add("active");
        checked = "checked";
        anyActive = true;
        this.$sortLabel.innerHTML = sort.label;
      }
      if (!anyActive && index === 0) {
        checked = "checked";
        this.$sortLabel.innerHTML = sort.label;
      }
      sortElement.innerHTML += `
          <label class="flex items-center gap-8 cursor-pointer">
            <input 
              type="radio" 
              class="size-20 js-sort-option redesign-radio-btn" 
              data-sort="sort.${sort.field}"
              data-sort-order="${sort.direction}"
              data-sort-label="${sort.label}"
              name="sort-articles"
              value="${sort.field}"
              ${checked}
            >
            ${sort.label} 
          </label>
      `;
      this.$sortArticlesContent.appendChild(sortElement);
    });
  }
  //------------------------------------------------------------------------------------------------
  toggleSortModal() {
    var _a, _b;
    if (this.$sortModalWrapper.classList.contains("hidden")) {
      this.$sortModalWrapper.classList.remove("hidden");
      this.$sortButton.setAttribute("aria-expanded", "true");
      document.body.classList.add("ui-active");
      window.$lastFocusedEl = document.activeElement;
      trapFocus(this.$sortModal);
      this.$sortModal._onEscape = () => this.toggleSortModal();
    } else {
      this.$sortModalWrapper.classList.add("hidden");
      this.$sortButton.setAttribute("aria-expanded", "false");
      document.body.classList.remove("ui-active");
      (_b = (_a = this.$sortModal)._removeTrapFocus) == null ? void 0 : _b.call(_a);
      this.$sortModal._onEscape = null;
      if (window.$lastFocusedEl) {
        window.$lastFocusedEl.focus();
      }
    }
  }
  //------------------------------------------------------------------------------------------------
  async handleSortChange(resultType = "products") {
    this.toggleSortModal();
    if (resultType === "products") {
      this.productsPageInfo = 1;
      this.ssUrlProducts = this.formatSearchSpringUrl("products");
      const ssProductData = await this.fetchSearchSpringData("products");
      this.initPage(ssProductData, null, "replace", "products");
    } else {
      this.articlesPageInfo = 1;
      this.ssUrlArticles = this.formatSearchSpringUrl("articles");
      const ssArticleData = await this.fetchSearchSpringData("articles");
      this.initPage(null, ssArticleData, "replace", "articles");
    }
    this.$sortLabel.innerHTML = this.sortLabel;
  }
  // **************************************************************************
  // FILTER METHODS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  toggleFiltersDrawer() {
    var _a, _b;
    if (this.$filtersDrawerWrapper.classList.contains("-translate-x-full")) {
      this.$filtersDrawerWrapper.classList.remove("-translate-x-full");
      this.$filtersDrawerWrapper.classList.add("translate-x-0");
      this.$filtersBackdrop.classList.remove("opacity-0", "pointer-events-none");
      this.$filtersBackdrop.classList.add("opacity-100");
      this.$filtersButton.setAttribute("aria-expanded", "true");
      document.body.classList.add("ui-active", "overflow-hidden");
      window.$lastFocusedEl = document.activeElement;
      trapFocus(this.$filtersDrawer);
      this.$filtersDrawer._onEscape = () => this.toggleFiltersDrawer();
    } else {
      this.$filtersDrawerWrapper.classList.add("-translate-x-full");
      this.$filtersDrawerWrapper.classList.remove("translate-x-0");
      this.$filtersBackdrop.classList.add("opacity-0", "pointer-events-none");
      this.$filtersBackdrop.classList.remove("opacity-100");
      this.$filtersButton.setAttribute("aria-expanded", "false");
      document.body.classList.remove("ui-active", "overflow-hidden");
      (_b = (_a = this.$filtersDrawer)._removeTrapFocus) == null ? void 0 : _b.call(_a);
      this.$filtersDrawer._onEscape = null;
      if (window.$lastFocusedEl) {
        window.$lastFocusedEl.focus();
      }
    }
    this.toggleFilterClearButton();
  }
  //------------------------------------------------------------------------------------------------
  toggleFilterClearButton() {
    if (this.productsActiveFilters && this.productsActiveFilters.length > 0 || this.articlesActiveFilters && this.articlesActiveFilters.length > 0) {
      this.$filtersClearButtonWrapper.classList.remove("hidden");
      this.$filtersContent.classList.add("pb-120");
    } else {
      this.$filtersClearButtonWrapper.classList.add("hidden");
      this.$filtersContent.classList.remove("pb-120");
    }
  }
  //------------------------------------------------------------------------------------------------
  addActiveFilters() {
    var _a, _b;
    if (!((_a = this.productsFiltersData) == null ? void 0 : _a.length) && !((_b = this.articlesFiltersData) == null ? void 0 : _b.length)) {
      console.warn("No filters available.");
      return;
    }
    if (!this.filtersInitialized) {
      this.$productsFiltersContent.innerHTML = "";
      this.$articlesFiltersContent.innerHTML = "";
    }
    if (!this.filtersInitialized) {
      this.buildFiltersUI(this.productsFiltersData, this.$productsFiltersContent);
      this.buildFiltersUI(this.articlesFiltersData, this.$articlesFiltersContent);
      this.filtersInitialized = true;
    }
    if (!this.eventsBound) {
      this.bindFilterEvents();
      this.eventsBound = true;
    }
  }
  buildFiltersUI(filtersData, container) {
    filtersData.forEach((filter) => {
      const isSingleVendorFilter = filter.field === "vendor" && filter.values.length === 1;
      if (isSingleVendorFilter) {
        return;
      } else if ((Shopify == null ? void 0 : Shopify.country) !== "US" && filter.field === "ss_price_range_filter") {
        return;
      }
      const filterElement = document.createElement("div");
      filterElement.classList.add("filter-item", "border-b-1", "border-charcoal-10");
      filterElement.innerHTML = `
        <button 
          type="button"
          id="acc-cta-${filter.field}" 
          class="flex items-center justify-between acc__btn js-acc-btn text-charcoal-100 cursor-pointer h-52"
          data-field="${filter.field}"
          aria-expanded="false" 
          aria-controls="acc-panel-${filter.field}"
        >
          <h3 class="filter-title redesign-label-2 text-charcoal-100">
            ${filter.label}
            <span 
              id="filter_count_${filter.field}"
              class="js-filter-count text-charcoal-80 ml-4"
              aria-live="polite"
            ></span>
          </h3>
          <span class="accordion-icons flex items-center justify-center size-32">
            ${_JK.icons.plus}
            ${_JK.icons.minus}
          </span>
        </button>
        <div id="acc-panel-${filter.field}" class="pt-22 pb-38 js-acc-menu" aria-hidden="true">
          <ul class="filter-options ${filter.label === "Color" || filter.label === "Size" ? "grid grid-cols-2 gap-4" : ""}">
            ${filter.values.map((value) => `
              <li class="filter-option redesign-body-7 py-8">
                <label class="flex items-center gap-10 cursor-pointer">
                  <input 
                    type="checkbox" 
                    class="js-filter-option redesign-checkbox-btn" 
                    data-filter="filter.${filter.field}" 
                    data-value="${value.value}"
                    ${value.active ? "checked" : ""}
                  >
                  <span class="text-charcoal-130 flex flex-row gap-4">
                    ${value.label}
                    <span class="text-charcoal-80">(${value.count})</span>
                  </span>
                </label>
              </li>
            `).join("")}
          </ul>
        </div>
      `;
      container.appendChild(filterElement);
    });
  }
  bindFilterEvents() {
    if (this.$productsFiltersContent) {
      this.$productsFiltersContent.addEventListener("change", (e) => {
        const target = e.target.closest(".js-filter-option");
        if (!target) return;
        e.stopPropagation();
        const filter = target.dataset.filter;
        const value = target.dataset.value;
        this.handleFilterChange(filter, value, target.checked);
      });
    }
    if (this.$articlesFiltersContent) {
      this.$articlesFiltersContent.addEventListener("change", (e) => {
        const target = e.target.closest(".js-filter-option");
        if (!target) return;
        e.stopPropagation();
        const filter = target.dataset.filter;
        const value = target.dataset.value;
        this.handleFilterChange(filter, value, target.checked);
      });
    }
  }
  //------------------------------------------------------------------------------------------------
  initFiltersAccordion() {
    if (this.resultType === "products") {
      this.$productsFiltersContent.classList.remove("hidden");
    } else {
      this.$articlesFiltersContent.classList.remove("hidden");
    }
    if (this.$filtersContent) {
      const accordion = SDG.accordion({
        dom: {
          btn: "js-acc-btn",
          id: this.$filtersContent.id,
          menu: "js-acc-menu"
        },
        open_option: this.activeFilterGroupIndex,
        type: "accordion"
      });
      accordion.init();
      this.$accordionButtons = this.$filtersContent.querySelectorAll(".js-acc-btn");
      this.$accordionButtons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.filterAccordionListener(e);
        });
      });
    }
  }
  //------------------------------------------------------------------------------------------------
  filterAccordionListener(e) {
    const accBtn = e.target.closest(".js-acc-btn");
    this.activeFilterGroupIndex = Number(accBtn.dataset.index);
  }
  //------------------------------------------------------------------------------------------------
  clearFilters() {
    this.$filterOptions = this.$filtersContent.querySelectorAll(".js-filter-option");
    this.$filterOptions.forEach((option) => {
      option.checked = false;
    });
    this.productsActiveFilters = [];
    this.articlesActiveFilters = [];
  }
  //------------------------------------------------------------------------------------------------
  async handleFilterChange(filter, value) {
    if (filter !== "" && value !== "") {
      if (this.resultType === "products") {
        const existingProductsFilterIndex = this.productsActiveFilters.findIndex((f) => f.key === filter && f.value === value);
        if (existingProductsFilterIndex > -1) {
          this.productsActiveFilters.splice(existingProductsFilterIndex, 1);
        } else {
          this.productsActiveFilters.push({ key: filter, value });
        }
      } else {
        const existingArticlesFilterIndex = this.articlesActiveFilters.findIndex((f) => f.key === filter && f.value === value);
        if (existingArticlesFilterIndex > -1) {
          this.articlesActiveFilters.splice(existingArticlesFilterIndex, 1);
        } else {
          this.articlesActiveFilters.push({ key: filter, value });
        }
      }
    } else {
      this.productsActiveFilters = [];
      this.articlesActiveFilters = [];
    }
    if (this.resultType === "products") {
      this.productsPageInfo = 1;
      this.ssUrlProducts = this.formatSearchSpringUrl("products");
      const ssProductData = await this.fetchSearchSpringData("products");
      this.initPage(ssProductData, null, "replace", "products");
    } else {
      this.articlesPageInfo = 1;
      this.ssUrlArticles = this.formatSearchSpringUrl("articles");
      const ssArticleData = await this.fetchSearchSpringData("articles");
      this.initPage(null, ssArticleData, "replace", "articles");
    }
    this.toggleFilterClearButton();
  }
  //------------------------------------------------------------------------------------------------
  displayFilterSummary(displayType = "products") {
    if (displayType === "products" || displayType === "both") {
      if (!this.productsFilterSummaryData || this.productsFilterSummaryData.length === 0) {
        this.$productsFilterSummaryWrapper.classList.add("hidden");
        this.$productsFilterSummaryWrapper.classList.remove("flex");
      } else {
        this.$productsFilterSummaryWrapper.classList.remove("hidden");
        this.$productsFilterSummaryWrapper.classList.add("flex");
        const productsSummaryItems = this.productsFilterSummaryData.map((filter) => `
          <button 
            class="js-remove-filter h-36 border-1 border-charcoal-10 hover:border-charcoal-40 text-charcoal-80 hover:text-charcoal-100 flex justify-center items-center gap-12 px-14 py-10 whitespace-nowrap"
            data-filter="filter.${filter.field}"
            data-value="${filter.value}"
            aria-label="Remove filter ${filter.label}"
          >
            <span class="filter-summary-item redesign-body-9">
              ${filter.label}
            </span>
            <span>${_JK.icons.closeSmall}</span>
          </button>
        `).join(" ");
        this.$productsFilterSummary.innerHTML = productsSummaryItems;
      }
    }
    if (displayType === "articles" || displayType === "both") {
      if (!this.articlesFilterSummaryData || this.articlesFilterSummaryData.length === 0) {
        this.$articlesFilterSummaryWrapper.classList.add("hidden");
        this.$articlesFilterSummaryWrapper.classList.remove("flex");
      } else {
        this.$articlesFilterSummaryWrapper.classList.remove("hidden");
        this.$articlesFilterSummaryWrapper.classList.add("flex");
        const articlesSummaryItems = this.articlesFilterSummaryData.map((filter) => `
          <button 
            class="js-remove-filter h-36 border-1 border-charcoal-10 hover:border-charcoal-40 text-charcoal-80 hover:text-charcoal-100 flex justify-center items-center gap-12 px-14 py-10 whitespace-nowrap"
            data-filter="filter.${filter.field}"
            data-value="${filter.value}"
            aria-label="Remove filter ${filter.label}"
          >
            <span class="filter-summary-item redesign-body-9">
              ${filter.label.replace(/Category:\s*/g, "")}
            </span>
            <span>${_JK.icons.closeSmall}</span>
          </button>
        `).join(" ");
        this.$articlesFilterSummary.innerHTML = articlesSummaryItems;
      }
    }
    const removeButtons = document.querySelectorAll(".js-remove-filter");
    removeButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const filterKey = e.currentTarget.dataset.filter;
        const filterValue = e.currentTarget.dataset.value;
        this.handleFilterChange(filterKey, filterValue);
      });
    });
  }
  // **************************************************************************
  // DATA HELPERS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  getQueryFromUrl() {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    const params = Array.from(urlParams.entries()).filter(([key]) => key === "q").map(([key, value]) => ({ key, value }));
    const q = params.length > 0 ? params[0].value : "no-results";
    return q;
  }
  //------------------------------------------------------------------------------------------------
  countKeyValues(arr, key, value) {
    return arr.reduce((count, obj) => {
      if (obj && obj[key] === value) {
        return count + 1;
      }
      return count;
    }, 0);
  }
  /**
  * updateSearchHistory
  * --------------------
  * Saves the current search query to localStorage under the key "search-history".
  * - Skips if the query is blank.
  * - Prevents duplicates (won’t re-add the same query).
  * - Maintains a maximum of 8 stored queries (removes the oldest when full).
  * - Used on the Search Results Page to persist a short history of searches
  *   that can be re-used by other components (e.g., header search).
  *
  * @param {string} q - The search query string
  */
  updateSearchHistory(q) {
    if (!q || q.trim() === "") return;
    const qList = [q];
    const searchHistoryMax = 8;
    const searchHistoryKey = "search-history";
    const localData = localStorage.getItem(searchHistoryKey);
    if (!localData) {
      localStorage.setItem(searchHistoryKey, JSON.stringify(qList));
    } else {
      let parsed = JSON.parse(localData);
      const sameQ = parsed.includes(q);
      if (!sameQ) {
        if (parsed.length >= searchHistoryMax) {
          parsed.shift();
        }
        parsed.push(q);
        localStorage.setItem(searchHistoryKey, JSON.stringify(parsed));
      }
    }
  }
}
class SearchWithPagination extends SRP {
  constructor() {
    super();
    this.pagination = new PaginationController({
      deskLimit: _JK.collections.deskResultsPerPage,
      mobLimit: _JK.collections.mobResultsPerPage,
      onChange: (newLimit) => this.updateSearchLimit(newLimit)
    });
    this.resultsPerPage = this.pagination.currentLimit;
  }
  updateSearchLimit(newLimit) {
    console.log("Search pagination changed to", newLimit);
    this.resultsPerPage = newLimit;
    this.init();
  }
}
document.addEventListener("DOMContentLoaded", () => {
  const $searchResultsContainer = document.getElementById("js-search-results-container");
  if ($searchResultsContainer) {
    const srp = new SearchWithPagination();
    srp.init();
  }
});
